export const BARN_ASSUMED_BULK_DENSITY = 640.739;
export const MINIMUM_GROUP_EVENT_DURATION = { hours: 1 };
